import useStoreMe from "@/hooks/store/useStoreMe";
import { UsersMeResponseDto } from "@/layouts/main/types";
import MyAxios from "@/utilize/MyAxios";
import { useQuery } from "@tanstack/react-query";
import { TQueryOptions } from "@/@types/axios";

export default function useGetMe(options: TQueryOptions = {}) {
  const { setMe } = useStoreMe();
  return useQuery({
    queryKey: ["me"],
    queryFn: () =>
      MyAxios.get<UsersMeResponseDto>("/users/me").then((res) => {
        setMe(res.data);
        return res.data;
      }),
    ...options,
  });
}
